import { render, staticRenderFns } from "./TopImage.vue?vue&type=template&id=5456227e"
import script from "./TopImage.vue?vue&type=script&lang=js"
export * from "./TopImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports